<template>
    <!-- 邮件分享 -->
    <div class="box">
        <el-main v-if="activeShare == 1">
            <div class="message_share">
                <div class="message_title">
                    <span class="message_text">{{$t('PublishProject.EmailSharing')}}</span>
                    <span class="view_share" style=" cursor: pointer;" @click="viewShareEmail()">{{$t('PublishProject.ViewSharedEmails')}}</span>
                </div>
                <el-card shadow="never" :body-style="{ padding: '0' }"  class="stepsbg">
                    <el-steps :active="ativeStep" align-center style="padding-top: 35px">
                        <el-step :title="$t('PublishProject.AddRecipient')"></el-step>
                        <el-step :title="$t('PublishProject.EditContent')"></el-step>
                        <el-step :title="$t('PublishProject.SelectSendingMethod')"></el-step>
                        <el-step :title="$t('PublishProject.Sent')"></el-step>
                    </el-steps>
                    <!-- 添加收件人 -->
                    <div v-if="ativeStep == 0" style="width: 920px; margin: 0 auto; padding-top: 30px">
                        <p
                            style="
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                line-height: 28px;
                                letter-spacing: 0px;
                                color: #666666;
                            "
                        >
                        {{ $t('PublishProject.EmailContactDescription') }}
                        </p>
                        <div class="Contact_table" style="margin-top: 20px">
                            <el-card shadow="never" :body-style="{ padding: '0' }">
                                <div class="setContact">
                                    <span>{{$t('PublishProject.ContactList')}}</span>
                                    <i  @click="setContact()" class="el-icon-setting setBtn"  title="管理联系人"></i>
                                </div>
                                <!--搜索框-->
                                <div class="searchInput">
                                    <el-input size="small" :placeholder="$t('PublishProject.InputContent')" prefix-icon="el-icon-search" v-model="input2" @input="searchInput2()"></el-input>
                                </div>
                                <!--添加列表-->
                                <div  v-if="input2.length > 0" class="treeBox2-box">
                                    <div v-for="(item, index) in searchTell" :key="index" class="treeBox2">
                                        <span class="treeBox2-title" :title="item.name">{{ item.name }}</span>
                                        <el-button type="text" @click="treeBox2_b(index)">{{$t('PublishProject.Add')}}</el-button>
                                    </div>
                                </div>
                                <!-- 联系人列表 -->
                                <div class="treeBox" v-if="input2.length == 0">
                                    <el-tree :data="options1" :props="props">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <span>
                                                {{ data.name }}
                                                <span v-if="data.contacts">{{ '(' + data.contacts.length + ')' }}</span>
                                            </span>
                                            <span class="btn" @click="addEmail(data)">引用</span>
                                        </span>
                                    </el-tree>
                                </div>
                            </el-card>
                            <el-card shadow="never" :body-style="{ padding: '0' }">
                                <div class="delContact">
                                    <span>{{$t('PublishProject.ManuallyEnteringContacts')}}</span>
                                    <el-button type="text" @click="delEmailContact()">清空</el-button>
                                </div>
                                <div class="email-contact-box">
                                    <!--邮件联系人添加处-->
                                    <div
                                        v-for="(item, index) in arrEmail"
                                        :key="index"
                                        style="
                                            margin-left: 10px;
                                            margin-top: 10px;
                                            color: #666;
                                            font-size: 14px;
                                            "
                                        :class="item.Email_error ? '' : 'Email_error'"
                                    >
                                        <span style="display: flex;justify-content: space-between;align-items: center;">
                                            {{ item.email }} &nbsp;, &nbsp;{{ item.name }}
                                            <i class="el-icon-delete right" style="margin-right: 15px; color: #0080ff; cursor: pointer;" @click="delEmailConlxr(index)"></i>
                                        </span>
                                    </div>
                                    <div id="emailContact" class="emailContact" contenteditable="ture" @keyup.enter="addemailContacts()"></div>
                                </div>
                            </el-card>
                        </div>
                        <div style="width: 646px; margin-left: 273px;margin-bottom: 20px;">
                            <div
                                style="
                                    margin-top: 10px;
                                    display: flex;
                                    justify-content: space-between;
                                    font-size: 14px;
                                    align-items: center;
                                "
                            >
                                <span v-if="lenEmail > 0">{{$t('PublishProject.NumberOfRecipients')}} : {{ lenEmail }}</span>
                                <span v-else>{{$t('PublishProject.NumberOfRecipients')}} : 0</span>

                                <el-button size="small" type="primary" :disabled="emailListErr" @click="nextStept()">{{$t('PublishProject.NextStep')}}</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 编辑内容 -->
                    <div v-if="ativeStep == 1" style="width: 920px; margin: 0 auto; padding-top: 30px">
                        <p
                            style="
                                font-family: MicrosoftYaHei;
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                letter-spacing: 0px;
                                color: #666666;
                            "
                        >
                            {{$t('PublishProject.InstructionsForUse')}}
                        </p>
                        <div>
                            <p style="margin-top: 19px">
                                <span>{{$t('PublishProject.Addresser')}}</span>
                                <el-input v-model="mail_recipient" style="margin-left: 10px;width: 200px;"></el-input>
                                <!-- <input
                                    type="text"
                                    v-model="mail_recipient"
                                    style="
                                        margin-left: 10px;
                                        width: 200px;
                                        height: 36px;
                                        color: #666;
                                        text-indent: 5px;
                                    "
                                /> -->
                                <span style="margin-left: 78px">{{$t('PublishProject.SenderEmail')}}</span>
                                <el-input v-model="sender_email" style="margin-left: 10px;width: 470px;"></el-input>
                                <!-- <input
                                    type="text"
                                    v-model="sender_email"
                                    style="
                                        margin-left: 10px;
                                        width: 470px;
                                        height: 36px;
                                        color: #666;
                                        text-indent: 5px;
                                    "
                                /> -->
                            </p>
                            <p style="margin-top: 19px; margin-bottom: 14px">
                                <span>{{$t('PublishProject.Theme')}}</span>
                                <el-input v-model="theme" style="margin-left: 20px;width: 854px;"></el-input>
                                <!-- <input type="text" v-model="theme" style="width: 854px; height: 36px; margin-left: 20px" /> -->
                            </p>
                        </div>
                        <div><vue-tinymce v-model="contentt" :setting="setting" /></div>
                        <div style="text-align: right; margin-top: 10px; height: 54px">
                            <el-button size="small" type="primary" @click="lastStep()">{{$t('PublishProject.Back')}}</el-button>
                            <el-button size="small" type="primary" @click="emailNextStept()">{{$t('PublishProject.NextStep')}}</el-button>
                        </div>
                    </div>
                    <!-- 选择发送方式 -->
                    <div
                        v-if="ativeStep == 2"
                        style="
                            width: 930px;
                            height: auto;
                            margin: 0 auto;
                            padding-top: 30px;
                        "
                    >
                        <div
                            style="
                                width: 930px;
                                height: 400px;
                                display: flex;
                                justify-content: space-around;
                            "
                        >
                            <div class="emali_fs" style="border: 1px solid #0080ff; width: 450px; height: 320px">
                                <div
                                    style="
                                        width: 100%;
                                        height: 170px;
                                        background: url('data:image/png;base64,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');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        text-align: center;
                                        line-height: 300px;
                                    "
                                >
                                    {{$t('PublishProject.SendViaEmail')}}
                                </div>
                                <p>{{$t('PublishProject.SendViaEmail1')}}</p>
                                <p>{{$t('PublishProject.SendViaEmail2')}}</p>
                                <p>
                                    {{$t('PublishProject.MailRemaining')}}:
                                    <span>{{ emailBalance }}</span>
                                    
                                    <!-- <a href="javascript:void(0);">充值购买</a> -->
                                    <router-link to="/emailRecharge" target="_blank" style="color: #2672ff">{{$t('PublishProject.RechargePurchase')}}</router-link>
                                </p>
                            </div>
                            <div class="emali_fs" style="border: 1px solid #ccc; width: 450px; height: 320px">
                                <div
                                    style="
                                        width: 100%;
                                        height: 170px;
                                        background: url('data:image/png;base64,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');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        text-align: center;
                                        line-height: 300px;
                                    "
                                >
                                    {{$t('PublishProject.SendUsingYourOwnEmail')}}
                                </div>
                                <p>{{$t('PublishProject.BindingRequired')}}</p>
                                <p style="margin-top: 20px">
                                    {{$t('PublishProject.LimitedToAdvancedVersionUse')}}
                                    <a href="javascript:void(0);" style="padding-left: 10px">
                                        {{$t('PublishProject.UpgradeNow')}}
                                        <span style="color: #aaa">( {{$t('PublishProject.NotYetOpen')}})</span>
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div style="text-align: right; margin-top: 10px; height: 54px">
                            <el-button size="small" type="primary" @click="lastStep()">{{$t('PublishProject.Back')}}</el-button>
                            <el-button size="small" type="primary" @click="sendEmails()">{{$t('PublishProject.Sending')}}</el-button>
                        </div>
                    </div>
                    <!-- 提交审核 -->
                    <div v-if="ativeStep == 3" style="width: 920px;min-height:200px; margin: 0 auto; padding-top: 30px">

                        <p class="justifyCenter" style="margin-top: 50px">{{$t('PublishProject.SubmittedForSending')}}</p>
                    </div>
                </el-card>
            </div>
        </el-main>
        <!-- 查看已发送邮件 -->
        <div class="sent-list" v-else-if="activeShare == 2">
            <PageHeader @back="backReturnEmail" :content="$t('PublishProject.SentMail')" />
            <!-- <el-page-header style="padding: 20px;" @back="backReturnEmail" :content="$t('PublishProject.SentMail')"></el-page-header> -->
            <div class="sent-list-table">
                <el-table :data="Messagesent" border height="calc(100vh - 164px)">
                    <el-table-column prop="emailContent" :label="$t('PublishProject.EmailSubject')" width="300" align="center"></el-table-column>
                    <el-table-column prop="emailNumber" :label="$t('PublishProject.NumberOfRecipients')" width="180" align="center"></el-table-column>
                    <el-table-column prop="sendState" :label="$t('PublishProject.SendingMethod')" width="180" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sendState == 0">{{$t('PublishProject.SendViaEmail')}}</span>
                            <span v-else>{{$t('PublishProject.SendUsingYourOwnEmail')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sendTime" :label="$t('PublishProject.SendingTime')" align="center"></el-table-column>
                    <el-table-column prop="state" :label="$t('PublishProject.State')" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state == 1">{{$t('PublishProject.Undelivered')}}</span>
                            <span v-else-if="scope.row.state == 2">{{$t('PublishProject.Delivered')}}</span>
                            <span v-else-if="scope.row.state == 3">{{$t('PublishProject.DeliveryFailed')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="auditReasons" :label="$t('PublishProject.Reason')" align="center"></el-table-column>
                    <el-table-column :label="$t('PublishProject.Operate')" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary" :underline="false" @click="seeDetailEmail(scope.row, 1, 10)">{{$t('PublishProject.ViewDetails')}}</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 查看已发送邮件详情 -->
        <div class="sent-list" v-else-if="activeShare == 3">
            <PageHeader @back="backViewEmailList" :content="$t('PublishProject.BackToTheListOfSentEmails')" />
            <!-- <el-page-header style="padding: 20px;" @back="backViewEmailList" :content="$t('PublishProject.BackToTheListOfSentEmails')"></el-page-header> -->
            <div class="sent-list-table">
                <el-table :data="emailDetailsData" border  height="calc(100vh - 204px)">
                    <el-table-column prop="email" :label="$t('PublishProject.Mailbox')" width="300" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.email">{{ scope.row.name }}</span>
                            <span v-else>{{$t('PublishProject.None')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" :label="$t('PublishProject.Name')" width="180" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.name">{{ scope.row.name }}</span>
                            <span v-else>{{$t('PublishProject.None')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sendTime" :label="$t('PublishProject.SendingTime')" width="180" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.sendTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="result" :label="$t('PublishProject.State')" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.result == 1">{{$t('PublishProject.Success')}}</span>
                            <span v-else>{{$t('PublishProject.Fail')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cause" :label="$t('PublishProject.Reason')" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.cause }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表格分页 -->
                <div style="padding: 10px; text-align: right">
                    <el-pagination
                        @current-change="emailCurrentChange"
                        :hide-on-single-page="page_value"
                        :current-page.sync="one_page.currentPageIndex"
                        :page-size="one_page.pageSize"
                        :total="one_page.totals"
                        class="fr"
                        background
                        layout="prev, pager, next, jumper"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :title="$t('main.tip')" :visible.sync="dialogWJVisible" width="20%" :close-on-click-modal="false">
			<span>{{$t('PublishProject.Wildcard')}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogWJVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="small" type="primary" @click="addWildcard">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
    </div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
    name: 'PublishProject',    
    components: {
        PageHeader
    },
	data() {
		return {
			wid: this.$route.query.wid,
			Messagesent: [],
			ativeStep: 0,
			arrayEmail: [], //邮件联系人
			searchTell: [], //输入查找的电话
			arrEmail: [],
			lenEmail: '',
			ifSel: 0,
			labelEm: '',
			emailId: '',			
            contentt: '',
            theme: '',
			loading: null,
			emailBalance: '',
			sendEmailContent: '',
			emailRowItem: {},
			emailDetailsData: [],
			one_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10 //一页显示几个
			},
            activeShare: 1,
			input2: '',
			options1: [],			
            props: {
				label: 'name',
				children: 'contacts'
			},
			emailListErr: true,
            dialogWJVisible: false,
            mail_recipient: this.$t('PublishProject.Recipient'),
			sender_email: `${this.$t('PublishProject.ForExample')}：ai@almail.ai-learning.com.cn`,
            setting: {
				menubar: false,
				toolbar:
					'undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |',
				toolbar_drawer: 'sliding',
				quickbars_selection_toolbar: 'removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor',
				plugins: 'link image media table lists fullscreen quickbars',
				language: 'zh_CN',
				height: 350
			},
		};
	},
	mounted() {
        this.queryContacts()
	},
	methods: {		
        // emailContacts() {
		// 	let that = this;
		// 	let id = that.wid;
		// 	let params = {
		// 		that: this,
		// 		url: `${this.$config.service.EmailContacts}`,
		// 		method: 'POST',
		// 		data: {
		// 			id: id
		// 		},
		// 		cb(res) {
		// 			if (res.code == 0) {
		// 				that.options1 = res.resultBody.datas;
		// 				console.log('获取邮件联系人', res);
		// 			}
		// 		}
		// 	};
		// 	this.$util.request(params);
		// },	
        queryContacts() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryContacts}`,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.options1 = res.resultBody.datas;
						console.log('获取联系人列表', that.options1);
					}
				}
			};
			that.$util.request(params);
		},
        unique(arr) {
			const res = new Map();
			return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, 1));
		},
        // 模糊搜索邮件
		searchInput2() {
			let that = this;
			let input2 = that.input2;
			let params = {
				that: that,
				url: `${that.$config.service.searchContacts}`,
				data: {
					search: input2
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.searchTell = res.resultBody.datas;
					}
				}
			};
			that.$util.request(params);
		},
		addWildcard() {
			this.contentt += '$[surveylink]';
			this.dialogWJVisible = false;
		},
		emailListVerify() {
			if (this.arrEmail.length > 0) {
				let errList = this.arrEmail.filter((info) => info.Email_error == false)
				this.emailListErr = errList.length > 0 ? true : false
			} else {
				this.emailListErr = true
			}
		},
        // 邮件富媒体联系人
		addemailContacts() {
			console.log(this.arrEmail);
			let that = this;
			let currentEmail = document.querySelector('#emailContact').innerText.replace('，', ',');
			let currentEmails = currentEmail.replace(/[\r\n]/g, '').split(',');
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			console.log(currentEmails);
			if (reg.test(currentEmails[0])) {
				that.Email_error = true;
			} else {
				that.Email_error = false;
			}
			document.querySelector('#emailContact').innerText = '';
			var EmailList = {};
			EmailList.email = currentEmails[0];
			EmailList.name = currentEmails.length >= 2 ? currentEmails[1] : '';
			EmailList.Email_error = reg.test(currentEmails[0]);
			that.arrEmail.push(EmailList);
			that.lenEmail = that.arrEmail.length;
			this.emailListVerify()
			console.log('创建的联系人', that.arrEmail);
		},
		//邮件返回
		backReturnEmail() {
			this.activeShare = 1;
		},
		// 返回已发送邮件列表
		backViewEmailList() {
			this.activeShare = 2;
		},
		viewShareEmail() {
			this.activeShare = 2;
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllEmail}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res, '邮件获取成功');
						that.Messagesent = res.resultBody.datas;
					} else {
						that.Messagesent = []
					}
				}
			};
			this.$util.request(params);
		},
        // 跳转联系人
		setContact() {
			this.$router.push('/contant');
		},		//搜索出来的联系人添加到右侧
		treeBox2_b(index) {
			//邮件
			let that = this;
			var treeemail = {};
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			treeemail.Email_error = reg.test(that.searchTell[index].email);
			treeemail.email = that.searchTell[index].email;
			treeemail.name = that.searchTell[index].name;
			that.arrEmail.push(treeemail);
			// that.arrEmail = that.unique(that.arrEmail);
			that.lenEmail = that.arrEmail.length;
			this.emailListVerify()
		},
		addEmail(data) {
			console.log('邮件联系人分享', data);
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;

			data.Email_error = reg.test(data.email);
			if (data.contacts) {
				for (let i = 0; i < data.contacts.length; i++) {
					console.log(data.contacts[i]);
					data.contacts[i].Email_error = reg.test(data.contacts[i].email);
					this.arrEmail.push(data.contacts[i]);
				}
			} else {
				// console.log(data);
				this.arrEmail.push(data);
			}

			this.arrEmail = this.unique(this.arrEmail);

			this.lenEmail = this.arrEmail.length;
			this.emailListVerify()
		},		// 邮件全删联系人
		delEmailContact() {
			let that = this;
			let arrEmail = that.arrEmail;
			for (let i = 0; i < arrEmail.length; i++) {
				arrEmail.splice(i);
			}
			that.lenEmail = this.arrEmail.length;
			this.emailListVerify()
		},		// 邮件单删联系人
		delEmailConlxr(index) {
			let that = this;
			let arrEmail = that.arrEmail;
			if (index > -1) {
				arrEmail.splice(index, 1);
			}
			that.lenEmail = this.arrEmail.length;
			this.emailListVerify()
		},
		nextStept() {
			let emData = [];
			for (let i = 0; i < this.arrEmail.length; i++) {
				emData.push({ cellphone: this.arrEmail[i].cellphone, email: this.arrEmail[i].email, name: this.arrEmail[i].name, iserId: this.arrEmail[i].id });
				console.log(this.arrEmail[i]);
			}
			if (emData.length) {
				let that = this;
				let id = that.wid;
				let params = {
					that: this,
					url: `${this.$config.service.addQuestionsEmail}`,
					method: 'POST',
					data: {
						ifSave: that.ifSel,
						questionsId: id,
						saveGroup: that.labelEm,
						smsContactsList: [...emData]
					},
					cb(res) {
						if (res.code == 0) {
							console.log('下一步成功', res);
							that.emailId = res.resultBody.id;
							that.contentt = res.resultBody.emailContent;
							that.theme = res.resultBody.questionsName;
							if (that.ativeStep++ > 2) this.ativeStep = 0;
						}
					}
				};
				this.$util.request(params);
			} else {
				this.$message.error(this.$t('PublishProject.NoContactsToSend'));
				return;
			}
		},		
        lastStep() {
			console.log('上一步');
			let that = this;
			if (that.ativeStep-- < 2) this.ativeStep = 0;
		},
        		// 邮件下一步
		emailNextStept() {
			let that = this;
			if (that.theme != '') {
				if (that.contentt.indexOf('$[surveylink]') == -1) {
					that.dialogWJVisible = true;
					return false;
				}
				that.loading = that.$loading({
					lock: true,
					text: that.$t('PublishProject.PleaseWaitAMoment'),
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let params = {
					that: this,
					url: `${this.$config.service.querySmsNumber}?type=email`,
					method: 'GET',
					data: {},
					cb(res) {
						that.loading.close();
						if (res.code == 0) {
							that.emailBalance = res.resultBody;
							that.sendEmailContent = tinyMCE.activeEditor.getContent();
							if (that.ativeStep++ > 2) that.ativeStep = 0;
						}
					}
				};
				this.$util.request(params);
			} else {
				that.$message.error(that.$t('PublishProject.FillInTheEmailSubject'));
			}
		},
        		// 发送邮件
		sendEmails() {
			if (this.emailBalance) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.sendEmail}`,
					method: 'POST',
					data: {
						addresser: '东方艾学',
						addresserEmail: 'ai@almail.ai-learning.com.cn',
						emailContent: that.sendEmailContent,
						id: that.emailId,
						sendState: 0,
						title: that.theme
					},
					cb(res) {
						if (res.code == 0) {
							console.log(res);
							that.$message.success(res.message);
							if (that.ativeStep++ > 2) that.ativeStep = 0;
						}
					}
				};
				this.$util.request(params);
			} else {
				this.$message.warning(this.$t('PublishProject.InsufficientEmailBalance'));
			}
		},
        		// 查看已发送邮件详情
		seeDetailEmail(row, pageIndex, pageSize) {
			console.log(row.id);
			let that = this;
			this.emailRowItem = row;
			this.activeShare = 3;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuestionsEmailSendDetails}?id=${row.id}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
				method: 'get',
				cb(res) {
					if (res.code == 0) {
						console.log('邮件详情', res);
						that.emailDetailsData = res.resultBody.datas;
						that.one_page.currentPageIndex = res.resultBody.pageIndex;
						that.one_page.pageSize = res.resultBody.pageSize;
						that.one_page.totals = res.resultBody.total;
					} else {
						that.emailDetailsData = [];
						that.one_page.currentPageIndex = 1;
						that.one_page.pageSize = 10;
						that.one_page.totals = 0;
					}
				}
			};
			this.$util.request(params);
		},
        emailCurrentChange(val) {
			let that = this;
			that.one_page.currentPageIndex = val;
			that.seeDetailEmail(that.emailRowItem, val, 10);
		}
	},
};
</script>

<style lang="scss" scoped="scoped">
.box{
    background-color: #fff !important;    
    margin: 0 auto;
}

.message_share {
	width: 1000px;
	height: auto;
	margin: auto;
}
.message_title {
	width: 1000px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}
.message_text {
	font-family: MicrosoftYaHei;
	font-size: 16px;
	color: #333333;
}
.view_share {
	font-family: MicrosoftYaHei;
	font-size: 14px;
	color: #0080ff;
}
.Contact_table {
	display: flex;
	justify-content: space-between;
}
.setContact {
	width: 254px;
	height: 43px;
	background-color: #f5f5f5;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.setContact .setBtn{
	cursor: pointer;
}
.setContact span {
	margin-left: 15px;
	font-size: 14px;
	color: #333;
}
.setContact i {
	color: #0080ff;
	margin-right: 20px;
}
.searchInput {
	width: 243px;
	margin: 17px auto;
}
.delContact i {
	margin-right: 15px;
	color: #0080ff;
}
.delContact span {
	font-size: 14px;
	color: #333;
}
.delContact {
	padding: 0 15px;
	width: 646px;
	height: 43px;
	display: flex;
	background: #f5f5f5;
	justify-content: space-between;
	align-items: center;
    box-sizing: border-box;
}
.treeBox2-box{
	font-size: 14px;
	height: 400px;
	overflow-y: scroll;
}

/*搜索手机号出来的div*/
.treeBox2 {
	padding: 5px 5px 5px 24px;
	display: flex;
    justify-content: space-between;
    align-items: center;
	height: 20px;
    line-height: 20px;
}
.treeBox2 .treeBox2-title{
	width: 200px;      /* 固定宽度 */
	white-space: nowrap; /* 禁止换行 */
	overflow: hidden;   /* 隐藏溢出 */
	text-overflow: ellipsis; /* 显示省略号 */
}
.treeBox2:hover {
	background: #c5e8fe;
}
.treeBox {
	width: 254px;
	font-size: 14px;
	height: 400px;
    overflow-y: scroll;
}
.custom-tree-node {
	width: 254px;
	position: relative;
	display: flex;
	align-items: center;
    justify-content: space-between;
}
.custom-tree-node .btn {
	color: #0080ff;
    font-size: 14px;
    cursor: pointer;
}
.email-contact-box{
	height: 470px;
    overflow-y: scroll;
}
/*手机号错误*/

.Email_error {
	color: red !important;
}
/*邮箱*/
#emailContact {
	outline: none;
}
.emailContact {
	outline: none;
	height: calc(520px - 70px);
	padding: 10px 20px;
}
.emali_fs p {
	padding: 20px 0px 0px 20px;
	font-size: 14px;
}
.justifyCenter {
	text-align: center;
	font-family: MicrosoftYaHei;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 32px;
	letter-spacing: 0px;
	color: #333333;
	margin-top: 15px;
}
.sent-list{
	background-color: #fff;
	width: 100%;
	height: calc(100vh - 60px);
	.sent-list-table{
		padding: 0 20px 20px 20px;
	}
}
</style>
